import mixpanel from "mixpanel-browser";

import { mixpanelToken } from "../config";
import { headless } from "./isHeadless";

if (mixpanelToken && !headless) {
    mixpanel.init(mixpanelToken, {
        api_host: "https://analytics.formant.io",
    });

    // Make ApplicationName available for Mixpanel Insights breakdowns on all events
    mixpanel.register({
        ApplicationName: "formant-web",
    });
}
